import React, { useContext, useEffect, useState } from 'react';
import {
  Typography,
  Button,
  Input,
  Select,
  Tabs,
  Card,
  message,
  Collapse,
  Form,
  Upload,
  Radio,
  ColorPicker,
  ConfigProvider,
  Avatar,
} from 'antd';
import {
  CaretRightOutlined,
  CopyOutlined,
  InboxOutlined,
  LinkOutlined,
  LoadingOutlined,
  MessageOutlined,
  SettingOutlined,
} from '@ant-design/icons';
const { Title, Text } = Typography;
const { Dragger } = Upload;
import PainBrush from '../../../../assets/customSVG/inbox/webchat/PainBrush';
import StickyBox from 'react-sticky-box';
import Team from './Team';
import ButtonGX from '../../page/webChat/ButtonGX';
import { useDispatch } from 'react-redux';
import {
  createWebChatChannelData,
  updateWebChatChannel,
  updateWebChatChannelData,
} from '../../../../reduxToolkit/channelSlice';
import { useSelector } from 'react-redux';
import { useFileUploader } from '../../../../hooks/useFileUploader';
import NotificationContext from '../../../../providers/NotificationProvider';
import {
  showErrorToast,
  showSuccessToast,
} from '../../../../components/commonComponents/gxAntdToast/toastUtils';
import { useNavigate } from 'react-router-dom';
import { cdnURL } from '../../../../api/ApiConfig';

const WebChatChannelEditor = ({ heading, type }) => {
  // hooks
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const toast = useContext(NotificationContext);

  // selectors
  const { selectedWebChatChannel, webChatChannelData } = useSelector(
    (state) => state.Channel
  );
  const { currentBrand } = useSelector((state) => state.app);

  // states
  const [updatedDetails, setUpdatedDetails] = useState({
    ...webChatChannelData,
  });
  const [isAnyFieldUpdated, setIsAnyFieldUpdated] = useState(false);
  const [enableSaveButton, setEnableSaveButton] = useState(false);

  // handlers
  const handleUpdateChannel = async () => {
    const body = {
      bot_id: webChatChannelData?.bot_id,
      channel_name: webChatChannelData?.name,
      logo: webChatChannelData?.details?.logo,
      bot_name: webChatChannelData?.details?.bot_name,
      welcome_message: webChatChannelData?.details?.welcome_message,
      position: webChatChannelData?.details?.position,
      theme_color: webChatChannelData?.details?.theme_color,
      team_id: webChatChannelData?.team_id,
      agent_id: webChatChannelData?.settings?.agent_id,
      deployed_website_url: webChatChannelData?.deployed_website_url,
    };
    const params = {
      channel: selectedWebChatChannel?.id,
      brand_id: currentBrand?.brand_id,
      data: body,
    };
    const res = await dispatch(updateWebChatChannelData(params));
    console.log(res);
    if (res?.type === 'webChat/update_webChat_channel_data/fulfilled') {
      showSuccessToast(toast, 'Channel updated successfully');
    }
  };

  const handleCreateChannel = async () => {
    const body = {};
    console.log({ webChatChannelData });

    if (!webChatChannelData?.bot_id) {
      showErrorToast(toast, 'Bot ID is required');
      return;
    }
    body['bot_id'] = webChatChannelData?.bot_id;
    if (webChatChannelData?.name) body['name'] = webChatChannelData?.name;
    if (webChatChannelData?.details?.logo)
      body['logo'] = webChatChannelData?.details?.logo;
    if (webChatChannelData?.details?.bot_name)
      body['bot_name'] = webChatChannelData?.details?.bot_name;
    if (webChatChannelData?.details?.welcome_message)
      body['welcome_message'] = webChatChannelData?.details?.welcome_message;
    if (webChatChannelData?.details?.position)
      body['position'] = webChatChannelData?.details?.position;
    if (webChatChannelData?.details?.theme_color)
      body['theme_color'] = webChatChannelData?.details?.theme_color;
    if (webChatChannelData?.deployed_website_url)
      body['deployed_website_url'] = webChatChannelData?.deployed_website_url;
    if (webChatChannelData?.team_select)
      body['team_id'] = webChatChannelData?.team_select;
    const params = {
      brand_id: currentBrand?.brand_id,
      data: body,
    };
    const res = await dispatch(createWebChatChannelData(params));
    console.log(res);
    if (res?.type === 'webChat/create_webChat_channel_data/fulfilled') {
      showSuccessToast(toast, 'Channel created successfully');
      // redirect to my channels
      navigate(
        `/user/channels/webchat/my-channels?channel=${res?.payload?.data?.uuid}`
      );
    }
  };

  const handleChange = ({ key, value }) => {
    const updated = { [key]: value };
    dispatch(updateWebChatChannel({ ...webChatChannelData, ...updated }));
  };

  const handleAppearanceChange = ({ key, value }) => {
    const updated = { [key]: value };
    dispatch(
      updateWebChatChannel({
        details: { ...webChatChannelData?.details, ...updated },
      })
    );
  };

  // render functions
  const renderTabBar = (props, DefaultTabBar) => (
    <StickyBox style={{ zIndex: 1, background: 'white' }}>
      <div>{heading}</div>
      <DefaultTabBar className="pt-2" {...props} />
    </StickyBox>
  );

  return (
    <div className="px-4 ">
      <ConfigProvider
        theme={{
          components: {
            Tabs: {
              inkBarColor: '#05805d', // active bar color
              colorPrimary: '#05805d',
            },
          },
        }}
      >
        <Tabs
          defaultActiveKey="1"
          items={[
            {
              key: '1',
              label: 'Configuration',
              children: (
                <WebChatChannelEditorConfig
                  type={type}
                  setEnableSaveButton={setEnableSaveButton}
                  handleChange={handleChange}
                />
              ),
              icon: <SettingOutlined />,
            },
            {
              key: '2',
              label: (
                <div className="flex items-center gap-2 select-none">
                  <PainBrush />
                  Appearance
                </div>
              ),
              children: (
                <WebChatWidgetAppearance
                  handleChange={handleAppearanceChange}
                />
              ),
            },
          ]}
          tabBarExtraContent={
            <div className="flex justify-end gap-3">
              {/* <Button disabled>Reset to Default</Button> */}
              <ButtonGX
                disabled={enableSaveButton}
                htmlType="submit"
                form="webChatWidgetAppearance"
                onClick={() => {
                  if (type === 'create') {
                    handleCreateChannel();
                  } else {
                    handleUpdateChannel();
                  }
                }}
              >
                {type === 'create' ? 'Create Channel' : 'Save Changes'}
              </ButtonGX>
            </div>
          }
          renderTabBar={renderTabBar}
        />
      </ConfigProvider>
    </div>
  );
};

export default WebChatChannelEditor;

const WebChatChannelEditorConfig = ({
  type,
  handleChange,
  setEnableSaveButton,
}) => {
  const { unassignedTeams, webChatChannelData } = useSelector(
    (state) => state.Channel
  );
  const { details } = webChatChannelData || {};
  const { logo, bot_name, welcome_message, position, theme_color } =
    details || {};
  console.log({ webChatChannelData });

  // Simple URL validation function
  function isValidUrl(str) {
    try {
      // Try constructing a new URL object
      new URL(str);
      return true;
    } catch (e) {
      return false;
    }
  }

  return (
    <div className="h-full p-4 pt-0 flex flex-col gap-3 bg-white">
      {/* Agent ID */}
      <div className="flex flex-col">
        <Title level={5}>Agent ID</Title>
        <Input
          onChange={(e) =>
            handleChange({ key: e?.target?.name, value: e?.target?.value })
          }
          placeholder="Your Agent ID"
          value={webChatChannelData?.bot_id}
          size="large"
          name="bot_id"
          // numeric
          type="number"
          className="w-full"
          disabled={type === 'edit'}
        />
      </div>
      {/* Channel Name */}
      <div>
        <Title level={5}>Channel Name</Title>
        <Input
          onChange={(e) =>
            handleChange({ key: e?.target?.name, value: e?.target?.value })
          }
          placeholder="Channel Name"
          value={webChatChannelData?.name}
          size="large"
          name="name"
          className="w-full"
        />
      </div>
      {/* Assign a Team */}
      <div className="flex flex-col mb-2">
        <Title level={5}>Assign a Team</Title>

        <Select
          suffixIcon={<CaretRightOutlined rotate={90} />}
          options={unassignedTeams?.map((item) => ({
            value: item?.id,
            label: <Team item={item} />,
          }))}
          disabled={type === 'edit'}
          onChange={(value) =>
            handleChange({ key: 'team_select', value: value })
          }
          value={webChatChannelData?.team_id}
          allowClear
          // popupClassName="max-w-max"
          size="large"
          className="min-h-fit "
        />
      </div>
      {/* Integrate Code */}
      <Collapse
        defaultActiveKey={['1']}
        expandIcon={({ isActive }) => (
          <CaretRightOutlined rotate={isActive ? 90 : 0} />
        )}
        expandIconPosition="end"
        items={[
          {
            key: '1',
            label: (
              <Title
                className="select-none"
                level={5}
                style={{ marginBottom: '0' }}
              >
                Integrate Code
              </Title>
            ),
            children: (
              <Card className="w-full">
                <div className="bg-gray-50 p-4 rounded-md relative">
                  <pre className="text-sm text-gray-800 overflow-x-auto">
                    {`
<!-- Add this code to your website's <head> section -->
<script>
      (function () {
        var chatbotConfig = {
          bot_id: '${webChatChannelData?.bot_id || ''}',
          position: '${position}',
          theme:
            'linear-gradient(90deg, rgb(34,116,174) 0%, rgb(135,208,104) 100%)',
          greeting: '${welcome_message}',
          logo: '${logo}',
          bot_name: '${bot_name}',
          access_key: '${webChatChannelData?.access_key || ''}',
          channel: '${webChatChannelData?.uuid || ''}'
        };

        function onReady(fn) {
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', fn);
          } else {
            fn();
          }
        }

        onReady(function () {
          window.gainwixConfig = chatbotConfig;

          if (!document.getElementById('GX_Chatbot')) {
            var div = document.createElement('div');
            div.id = 'GX_Chatbot';
            document.body.appendChild(div);
          }

          if (
            !document.querySelector(
              'link[href="${cdnURL}/chatbot/V2/index.css"]'
            )
          ) {
            var link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href =
              '${cdnURL}/chatbot/V2/index.css';
            document.head.appendChild(link);
          }

          if (
            !document.querySelector(
              'script[src="${cdnURL}/chatbot/V2/index.js"]'
            )
          ) {
            var script = document.createElement('script');
            script.type = 'module';
            script.src =
              '${cdnURL}/chatbot/V2/index.js';
            document.body.appendChild(script);
          }
        });
      })();
    </script>
                      `}
                  </pre>
                  <Button
                    type="text"
                    icon={<CopyOutlined />}
                    className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                    onClick={() => {
                      navigator.clipboard.writeText(
                        document.querySelector('pre').innerText
                      );
                      message.success('Code copied to clipboard!');
                    }}
                  >
                    Copy
                  </Button>
                </div>
                <div className="mt-4">
                  <Text type="secondary" className="text-sm">
                    Paste this code snippet before the closing{' '}
                    <code>&lt;/body&gt;</code> tag of your website to enable the
                    web chat widget.
                  </Text>
                </div>
              </Card>
            ),
          },
        ]}
      />
      <div>
        <Title level={5}>website URL</Title>
        <Input
          placeholder="https://myAwesomeWebsite.com"
          size="large"
          type="url"
          value={webChatChannelData?.deployed_website_url}
          onChange={(e) => {
            if (!isValidUrl(e.target.value)) {
              setEnableSaveButton(true);
            } else {
              setEnableSaveButton(false);
            }

            handleChange({
              key: 'deployed_website_url',
              value: e.target.value,
            });
          }}
          addonBefore={<LinkOutlined />}
          defaultValue="mysite"
        />
      </div>
    </div>
  );
};

const WebChatWidgetAppearance = ({ handleChange }) => {
  const { webChatChannelData } = useSelector((state) => state.Channel);
  const { currentBrand } = useSelector((state) => state.app);
  console.log({ webChatChannelData });
  const { details } = webChatChannelData || {};
  const { logo, bot_name, welcome_message, position, theme_color } =
    details || {};
  const [form] = Form.useForm();
  const {
    uploadFiles,
    responseFile: uploadedFileUrl,
    error: uploadError,
    uploading,
    dimensionError,
  } = useFileUploader();

  useEffect(() => {
    if (uploadedFileUrl) {
      handleChange({
        key: 'logo',
        value: uploadedFileUrl,
      });
      // setLogoPreview();
      handleChange({
        key: 'logo',
        value: uploadedFileUrl,
      });
    }
  }, [uploadedFileUrl]);

  const handleFileChange = (file) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/jpeg,image/png';
    input.onchange = async (e) => {
      if (e.target.files && e.target.files[0]) {
        await uploadFiles(e, 'IMAGE', 5, {
          path: 'web-chat-icon',
          brand_id: currentBrand?.brand_id,
        }); // 5MB max size for images
      }
    };
    input.click();
    return false;
  };

  const props = {
    name: 'file',
    multiple: false,
    showUploadList: false,
    beforeUpload: handleFileChange,
  };

  const positionOptions = [
    { label: 'Left', value: 'left' },
    { label: 'Right', value: 'right' },
  ];

  // for gradient color picker
  const DEFAULT_COLOR = [
    {
      color: 'rgb(16, 142, 233)',
      percent: 0,
    },
    {
      color: 'rgb(135, 208, 104)',
      percent: 100,
    },
  ];

  return (
    <div className="p-4">
      <Form
        id="webChatWidgetAppearance"
        form={form}
        layout="vertical"
        initialValues={{
          botName: bot_name,
          position: position,
          welcomeMessage: welcome_message,
        }}
      >
        {/* <div className="flex justify-end gap-3">
          <Button>Reset to Default</Button>
          <Button type="primary">Save Changes</Button>
        </div> */}
        <div className="grid grid-cols-1 2xl:grid-cols-2 gap-6">
          {/* Left Column */}
          <div className="space-y-6">
            <Card title="Bot Settings" className="w-full border-slate-300 ">
              <Form.Item
                label="Bot Logo"
                name="botLogo"
                rules={[{ required: true, message: 'Please upload a logo' }]}
                help={
                  uploadError
                    ? 'File size is too large (max 5MB)'
                    : dimensionError
                    ? 'Minimum image dimensions: 320x320px'
                    : ''
                }
                validateStatus={uploadError || dimensionError ? 'error' : ''}
              >
                <Dragger
                  {...props}
                  className="w-full h-40"
                  disabled={uploading}
                >
                  {uploading ? (
                    <div className="flex flex-col items-center justify-center p-4">
                      <LoadingOutlined className="text-2xl text-gray-400 mb-2" />
                      <p className="text-sm text-gray-500">Uploading...</p>
                    </div>
                  ) : logo ? (
                    <div className="relative w-full h-full flex items-center justify-center">
                      <img
                        src={logo}
                        alt="Bot Logo"
                        className="max-h-32 max-w-full object-contain"
                      />
                      <div className="absolute inset-0 bg-black bg-opacity-0 hover:bg-opacity-20 transition-all duration-200 flex items-center justify-center opacity-0 hover:opacity-100">
                        <Button type="primary">Change Logo</Button>
                      </div>
                    </div>
                  ) : (
                    <div className="flex flex-col items-center justify-center p-4">
                      <InboxOutlined className="text-2xl text-gray-400 mb-2" />
                      <p className="text-sm text-gray-500">
                        Click or drag file to upload
                      </p>
                      <p className="text-xs text-gray-400">
                        Recommended size: 320x320px (min)
                      </p>
                    </div>
                  )}
                </Dragger>
              </Form.Item>

              <Form.Item
                label="Bot Name"
                name="botName"
                rules={[
                  { required: true, message: 'Please input the bot name!' },
                ]}
              >
                <Input
                  size="large"
                  placeholder="Enter bot name"
                  onChange={(e) =>
                    handleChange({ key: 'bot_name', value: e.target.value })
                  }
                  value={bot_name}
                />
              </Form.Item>

              <Form.Item
                label="Welcome Message"
                name="welcomeMessage"
                rules={[
                  {
                    required: true,
                    message: 'Please input the welcome message!',
                  },
                ]}
              >
                <Input.TextArea
                  rows={3}
                  placeholder="Enter welcome message"
                  showCount
                  maxLength={200}
                  onChange={(e) =>
                    handleChange({
                      key: 'welcome_message',
                      value: e.target.value,
                    })
                  }
                  value={welcome_message}
                />
              </Form.Item>
            </Card>
          </div>

          {/* Right Column */}
          <div className="space-y-6">
            <Card title="Display Settings" className="w-full border-slate-300 ">
              <Form.Item
                label={
                  <Text className="font-semibold">Chat Widget Position</Text>
                }
                style={{ marginBottom: '1rem' }}
                name="position"
                rules={[
                  { required: true, message: 'Please select a position!' },
                ]}
              >
                <Radio.Group
                  optionType="button"
                  buttonStyle="solid"
                  className="w-full"
                >
                  {positionOptions.map((option) => (
                    <Radio.Button
                      key={option.value}
                      value={option.value}
                      onChange={() => {
                        handleChange({
                          key: 'position',
                          value: option.value,
                        });
                      }}
                      className="flex-1 text-center"
                    >
                      {option.label}
                    </Radio.Button>
                  ))}
                </Radio.Group>
              </Form.Item>

              <Form.Item label={<Text className="font-semibold">Theme</Text>}>
                <div className="space-y-4">
                  <div className="flex items-center gap-4">
                    <span className="text-sm text-gray-600 w-24">
                      Solid Color
                    </span>
                    <ColorPicker
                      value={
                        theme_color?.startsWith('linear-gradient')
                          ? '#1890ff'
                          : theme_color
                      }
                      onChange={(color) => {
                        handleChange({
                          key: 'theme_color',
                          value: color.toHexString(),
                        });
                      }}
                      showText
                      className="flex-1"
                      // disabled={theme_color?.startsWith('linear-gradient')}
                    />
                  </div>

                  <div className="flex items-center gap-4">
                    <span className="text-sm text-gray-600 w-24">Gradient</span>
                    <div className="flex-1">
                      <ColorPicker
                        defaultValue={DEFAULT_COLOR}
                        allowClear
                        showText
                        className="w-full"
                        mode="gradient"
                        onChange={(color) => {
                          handleChange({
                            key: 'theme_color',
                            value: color.toCssString(),
                          });
                        }}
                        onChangeComplete={(color) => {
                          console.log(color.toCssString());
                        }}
                      />
                    </div>
                  </div>
                </div>
              </Form.Item>

              <Form.Item label="Preview" className="mt-8">
                <div className="relative border border-dashed border-gray-200 rounded-lg p-6 h-48">
                  <div
                    className={`w-16 h-16 rounded-full flex items-center justify-center cursor-pointer shadow-md absolute bottom-4 ${
                      position === 'right' ? 'right-4' : 'left-4'
                    }`}
                    style={{
                      backgroundColor: theme_color,
                      width: 50,
                      height: 50,
                      borderWidth: 2,
                      padding: 2,
                      background: `linear-gradient(white, white) padding-box, ${theme_color} border-box`,
                      border: '2px solid transparent',
                    }}
                  >
                    {/* <MessageOutlined className="text-white text-2xl" /> */}
                    <Avatar src={logo} />
                  </div>
                </div>
              </Form.Item>
            </Card>

            {/* <div className="flex justify-end gap-3">
              <Button>Reset to Default</Button>
              <Button type="primary">Save Changes</Button>
            </div> */}
          </div>
        </div>
      </Form>
    </div>
  );
};
